import React from "react";
import CountUp from "react-countup"; // Import CountUp

const StatsSection = () => {
  return (
    <div className="bg-[#e9a200] py-20 px-8 rounded-xl">
      <div className="container mx-auto text-center">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-y-12 gap-x-8">
          <div className="stat-item">
            <span className="text-4xl md:text-5xl font-bold text-white">
              <CountUp start={0} end={1000} duration={6} separator="," />+
            </span>
            <p className="text-lg md:text-xl text-white mt-2">Projects</p>
          </div>
          <div className="stat-item">
            <span className="text-4xl md:text-5xl font-bold text-white">
              <CountUp start={0} end={2000} duration={6} separator="," />+
            </span>
            <p className="text-lg md:text-xl text-white mt-2">Happy Clients</p>
          </div>
          <div className="stat-item">
            <span className="text-4xl md:text-5xl font-bold text-white">
              <CountUp start={0} end={25} duration={6} />+
            </span>
            <p className="text-lg md:text-xl text-white mt-2">Design Experts</p>
          </div>
          <div className="stat-item">
            <span className="text-4xl md:text-5xl font-bold text-white">
              <CountUp start={0} end={10} duration={6} />+
            </span>
            <p className="text-lg md:text-xl text-white mt-2">
              Years of Expertise
            </p>
          </div>
          <div className="stat-item">
            <span className="text-4xl md:text-5xl font-bold text-white">
              <CountUp start={0} end={45} duration={6} />+
            </span>
            <p className="text-lg md:text-xl text-white mt-2">GHS WorkForce</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsSection;
